import React, { useEffect, useState } from 'react';
import {
	giftCard,
	merchantGiftCard,
	giftCardUpdate,
	allgiftCard,
	getAllGiftcard,
	getGiftcards,
	updateMerchantGiftcards,
} from '../../actions/auth';
import swal from 'sweetalert';
import Header from '../layout/Header';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Paginated from './Paginated';
import { COLUMN } from './COLUMN';
import { decrypt, encrypt } from '../../utils/encodingdecoding';
import { backIcon2 } from '../../Image/Index';
import AdminHeader from '../layout/AdminHeader';
import { useDispatch } from 'react-redux';

const GiftCard = () => {
	const [formData, setFormData] = useState([]);
	let navigate = useNavigate();
	const [loader, setLoader] = useState(false);
	const [response, setResponse] = useState([]);
	const [matchedData, setMatchedData] = useState([]);
	const location = useLocation();
	const [list, setList] = useState([]);

	const data = location?.state?.datas || [];
	const clientID = (() => {
		try {
			const venClientCode = sessionStorage.getItem('venClientCode');
			return venClientCode ? decrypt(venClientCode) : '';
		} catch {
			return '';
		}
	})();
	const uniqueVendorCodes = [
		...new Set(data.map((item) => item.vendor_code)),
	].join(',');
	const dispatch = useDispatch();
	const fetch = async () => {
		setLoader(true);
		try {
			let res = await dispatch(getGiftcards({ status: 1 }));
			// let res = await getAllGiftcard();
			setResponse(res.data);
			setList(data);
		} catch (error) {}
		setLoader(false);
	};

	useEffect(() => {
		let matched = response?.filter((item) =>
			data?.some((resp) => resp?.id === item?.id && resp?.status),
		);
		setMatchedData(matched);
	}, [response, data]);
	const handleDiscountChange = (e, id) => {
		const { value } = e.target;
		setList((prev) =>
			prev.map((ele) =>
				ele.id === id ? { ...ele, discount: value } : ele,
			),
		);
	};
	useEffect(() => {
		fetch();
	}, []);

	const onSubmit = async () => {
		setLoader(true);
		let response = await dispatch(
			updateMerchantGiftcards({
				giftcard_list: list.map((item) => ({
					id: item.id,
					status: Number(item.status),
					discount: Number(item.discount),
				})),
				client_id: encrypt(clientID),
			}),
		);
		if (
			response?.message?.status_code === 200 &&
			response?.message?.message ===
				`Giftcard(${response?.message?.data.length}) Updated successfully`
		) {
			swal({
				position: 'center',
				icon: 'success',
				title: `Giftcard Updated successfully`,
				showConfirmButton: false,
				timer: 2000,
			});
			navigate('/admin/client-list', { replace: true });
		} else if (
			response?.message?.message === 'Request failed with status code 500'
		) {
			swal({
				position: 'center',
				icon: 'error',
				title: 'Please add gift card list',
				showConfirmButton: false,
				timer: 5000,
			});
		} else {
			swal({
				position: 'center',
				icon: 'error',
				title: response?.message?.message,
				showConfirmButton: false,
				timer: 5000,
			});
		}
		setLoader(false);
	};

	return (
		<>
			<AdminHeader name={'Gift Card'} />
			{loader && (
				<div className='mainPreloaderMain'>
					<div className='mainPreloader'>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
						<div></div>
					</div>
				</div>
			)}
			<div className='dashboard__content'>
				<div className='container-fluid'>
					<div className='dashboard__heading'>
						<div className='dashboard__headingLeft'>
							<div className='dashboard__headingBackLink'>
								<Link
									to=''
									onClick={() => navigate(-1)}>
									<img
										src={backIcon2}
										alt=''
									/>
								</Link>
							</div>
							<div className='dashboard__headingContent'>
								<h3>Back</h3>
							</div>
						</div>
					</div>
					<div className='row'>
						<div className='dashboard__customersCard'>
							<div className='dashboard__header'>
								<div className='dashboard__left'>
									<h4 id='voucher_details'>
										Update discount for gift card
									</h4>
								</div>
							</div>
							<div className='dashboard__body'>
								{/* <Paginated data={formData ? formData : []} columns={COLUMN} /> */}
								{matchedData.map((item, index) => (
									<div
										className='giftcard_viewRow'
										key={index}>
										<div className='giftcard_view_imageBox'>
											<img src={item?.image}></img>
										</div>
										<div className='giftcard_view_contentBox'>
											<h3>{item?.title}</h3>
											{/* <span>{item?.category_code}</span> */}
										</div>
										<div className='giftcard_view_inputBox'>
											<label>Enter Discount (%)</label>
											<input
												type='text'
												// value={
												// 	item?.client_details &&
												// 	clientID in
												// 		item?.client_details
												// 		? item?.client_details[
												// 				clientID
												// 		  ].discount
												// 		: ''
												// }
												value={
													list.find(
														(items) =>
															items.id ===
															item.id,
													)?.discount || ''
												}
												onChange={(e) =>
													handleDiscountChange(
														e,
														item.id,
													)
												}
											/>
										</div>
										{/* <div className="giftcard_view_buttonBox">
                                            <button type="submit" onClick={onSubmit} className="btn btn-primary" >Update</button>
                                        </div> */}
									</div>
								))}
								<div
									className='row'
									style={{ paddingBottom: '20px' }}>
									<div className='col-sm-12  col-md-12 col-lg-12 col-xl-12'>
										<div
											className='button-section'
											style={{
												display: 'flex',
												justifyContent: 'flex-end',
											}}>
											<button
												type='submit'
												onClick={onSubmit}
												className='btn btn-primary'>
												Update
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default GiftCard;
